import Vue from 'vue';
import VueRouter from 'vue-router';
import {routes} from '@/router/routes.js';
import {NProgress} from '@/util/nprogress.js';
import commons from '../util/commons';

Vue.use(VueRouter);
//引入加载条
let router = new VueRouter({
	mode:'history',
	scrollBehavior(to,from,savedPosition){
		if(savedPosition){
			return savedPosition;
		}else if(to.hash){
			return {selector: to.hash};
		}
    return {x:0,y:0};
	},
	routes
})
router.beforeEach((to, from, next) => {
  NProgress.configure({ parent: 'body' });
  if (to.meta.NProgress) {
    NProgress.start();
  }
  NProgress.configure({ parent: 'body' });
  const localUser = commons.readTodos('localUser');
  // 如果需要登陆
  if (to.meta.requireAuth) {
    // 如果没有登录
    if (localUser === null) {
      // 未登录则跳转登陆页面
      next({ path: '/login' });
    }else{
      next();
    }
  } else {
    next();
  }
});
router.afterEach(transition => {
    NProgress.done();
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js